import { Observable } from 'rxjs';
import { Rpc } from '../rpc';
import { RpcObservableClient } from '../rpc-observable-client';
import { RpcOutbound } from '../rpc-outbound';
import {
    RpcObservableCopilotError, RpcObservableCopilotKey, RpcObservableCopilotRequest, RpcObservableCopilotResult
} from './rpc-observable-copilot-model';

/**
 * Iframe to Shell pair, the sending/Iframe port.
 */
export class RpcObservableCopilotClient
    extends RpcObservableClient<RpcObservableCopilotRequest, RpcObservableCopilotResult, RpcObservableCopilotError>  {

    /**
     * Initializes a new instance of the RpcObservableCopilotClient class.
     *
     * @param rpc the rpc object.
     */
    constructor(rpc: Rpc) {
        super(rpc, RpcObservableCopilotKey.command, RpcObservableCopilotKey.version);
    }

    /**
     * The Copilot command.
     *
     * @param request the Rpc Copilot data object.
     * @param outbound the Rpc outbound channel object.
     * @return Observable<RpcObservableCopilotResult> the observable object.
     */
    public log(request: RpcObservableCopilotRequest, outbound?: RpcOutbound): Observable<RpcObservableCopilotResult> {
        return this.observableCall(request, outbound);
    }
}
